import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
    const { currentUser, isAdmin, loading } = useAuth();

    // Wait for Firebase auth state to be determined before deciding
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <div style={{ fontSize: 16, color: '#666' }}>Loading...</div>
            </div>
        );
    }

    if (!currentUser || !isAdmin) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default PrivateRoute;
